import { makeStyles } from '@material-ui/core';
import appColors from 'utils/appColors';
import styled from 'styled-components';

const drawerWidthPx = 256;

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: appColors.BACKGROUND_COLOR,
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    position: 'relative',
  },
  backdrop: {
    zIndex: theme.zIndex.modal,
    color: '#fff',
  },
  content: {
    flex: '1 1 auto',
    minWidth: 0,
    boxSizing: 'border-box',
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
    paddingTop: 80,
    minHeight: 'calc(100vh - 0px)',
    position: 'relative',
    zIndex: 1,
    overflowX: 'hidden',
  },
  /**
   * O Drawer permanente do MUI fica position:fixed no paper — não empurra o <main>.
   * Repete o deslocamento do AppBar para o conteúdo não ficar por baixo da sidebar.
   */
  mainDrawerOpen: {
    marginLeft: drawerWidthPx,
    width: `calc(100% - ${drawerWidthPx}px)`,
    maxWidth: `calc(100% - ${drawerWidthPx}px)`,
    transition: theme.transitions.create(['margin', 'width', 'max-width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  mainDrawerCollapsed: {
    marginLeft: theme.spacing(8),
    width: `calc(100% - ${theme.spacing(8)})`,
    maxWidth: `calc(100% - ${theme.spacing(8)})`,
    transition: theme.transitions.create(['margin', 'width', 'max-width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(9),
      width: `calc(100% - ${theme.spacing(9)})`,
      maxWidth: `calc(100% - ${theme.spacing(9)})`,
    },
  },
}));

export const DefaultContainer = styled.div`
  padding-top: 7%;
  text-align: flex-start;
  margin-left: 14%;
  @media (max-width: 1920px) {
    padding-top: 5.5%;
    margin-left: 13.5%;
  }
  @media (max-width: 1440px) {
    padding-top: 7.5%;
    margin-left: 20%;
    margin-right: 1%;
  }
  @media (max-width: 1366px) {
    padding-top: 8%;
    margin-left: 20%;
  }
  @media (max-width: 1024px) {
    padding-top: 12%;
    margin-left: 5000%;
  }
  @media (max-width: 1600px) {
    padding-top: 7%;
    margin-left: 17%;
  }
  @media (max-width: 1660px) {
    padding-top: 5%;
    margin-left: 16%;
  }
  @media (max-width: 768px) {
    padding-top: 12%;
    margin-left: 27%;
  }
`;
